import React from 'react';
import { Columns } from '@components/Columns';
import { CharityDonationSection, CharityTextPairing, DogImage, TextPairBox, StyledTextColumn } from './CharityRegistry.styles';
import { registryPageData } from '@data-ts/pages/registry';
import ReactHtmlParser from 'react-html-parser';

const charityRegistryData = registryPageData.charityRegistrySection;

interface CharityRegistryProps {}

export const CharityRegistry: React.FC<CharityRegistryProps> = () => {
  return (
    <CharityDonationSection as="section" id="Charity_Registry">
      <TextPairBox>
        <StyledTextColumn centered>
          <Columns.Column width={6}>
            <CharityTextPairing
              alignment="center"
              eyebrow={charityRegistryData.eyebrow}
              eyebrowColor="humana5"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={ReactHtmlParser(charityRegistryData.title)}
              titleVariant="hed56"
              titleColor="humana6"
              titleTagName="h2"
              body={charityRegistryData.body}
              bodyVariant="dek24"
              bodyColor="neutra6"
              bodyTagName="p"
            />
          </Columns.Column>
        </StyledTextColumn>
      </TextPairBox>
      <Columns centered>
        <Columns.Column width={12}>
          <DogImage src="registry-v2/charity-registry/charity-v2.jpg" />
        </Columns.Column>
      </Columns>
    </CharityDonationSection>
  );
};
